module.exports = __webpack_public_path__ + "static/media/disapprove_icon.8532194f.svg";